import { render, staticRenderFns } from "./DocMustRead.vue?vue&type=template&id=1b2ed0a1&scoped=true"
import script from "./DocMustRead.vue?vue&type=script&lang=js"
export * from "./DocMustRead.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b2ed0a1",
  null
  
)

export default component.exports